import React from 'react';
import { string, number } from 'prop-types';
import Stats from './Stats';
import Description from './Description';

import './style.scss';

const StatsDesc = (props) => {
    const {
        description,
        recentDelivery,
        countryCode,
        memberSince,
        responseTime
    } = props;

    return (
        <div className="stats-desc">
            <Stats countryCode={countryCode}
                memberSince={memberSince}
                responseTime={responseTime}
                recentDelivery={recentDelivery}/>
            {description &&
            <Description userDescription={description}/>
            }
        </div>
    );
};

StatsDesc.propTypes = {
    description: string,
    recentDelivery: number,
    countryCode: string,
    memberSince: number,
    responseTime: number
};

export default StatsDesc;
